export default __webpack_public_path__ + "static/media/040-mailbox.f93dba08.svg";